import axios from "axios";

export default {
    name: "financing",
    state: {
        list: Array,
        pageMode: String,
        information: {},
        dataProcessed: {
            information: {},
            detail: [],
            total_pokok: 0
        },
        initial: {
            contract: [],
            financing: []
        }
    },
    getters: {
        getListPenarikanFinancing: state => {
            return state.list
        },
        getDataProcessed: state => {
            return state.dataProcessed
        },
        getPenarikanInformationFinancing: state => {
            return state.information
        },
        getPageMode: state => {
            return state.pageMode
        },
        getInitial: state => {
            return state.initial
        }
    },
    mutations: {
        setListPenarikanFinancing: (state, payload) => {
            state.list = payload
        },
        setPageMode: (state, payload) => {
            state.pageMode = payload
        },
        setInformation: (state, payload) => {
            state.information = payload
            state.dataProcessed.information = payload
        },
        setDetail: (state, payload) => {
            state.dataProcessed.detail = [...state.dataProcessed.detail, payload]
        },
        setTotalPokok: (state, payload) => {
            state.dataProcessed.total_pokok = payload
        },
        setInitialState: (state) => {
            state.dataProcessed = {
                information: {},
                detail: [],
                total_pokok: 0
            },
            state.information = {}
        },
        setinitial: (state, payload) => {
            state.initial = payload
        },
        removeDetailPenarikan: (state, payload) => {
            const source = state.dataProcessed.detail;
            const index = source.findIndex((data) => data === payload);

            source.splice(index, 1);
            state.dataProcessed.detail = source
        },
        editDetailPenarikan: (state, payload) => {
            const source = [...state.dataProcessed.detail];
            const find = source.findIndex((item) => item.id === payload.id);

            if (find >= 0) {
                source[find] = payload
                state.dataProcessed.detail = source
            }
        },
    },
    actions: {
        getListPenarikanFinancing(store, { auth }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "penarikan_financing",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setListPenarikanFinancing", response.data.data)
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getManifestPenarikanFinancing(store, { id, auth }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "penarikan_financing",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        id_penarikan_financing: id,
                        tlc: auth.username
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getDetailHistoryPenarikan(store, { id, auth }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "penarikan_financing/bukti_transfer",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        id_penarikan_financing_dtl: id,
                        tlc: auth.username
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getAllInputData(store, { auth }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "penarikan_financing/data_input",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        submitPenarikanFinancing(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + "penarikan_financing",
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then(({ data, status }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        submitPenarikanFinancingEdit(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + "penarikan_financing/edit",
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then(({ data, status }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getPenarikanFinanceEdit(store, { auth, params }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "Penarikan_financing/edit",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: params,
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
};
